interface ServerConfig {
  domain: string;
  apiUrl: string;
}

const SERVER_CONFIGS: ServerConfig[] = [
  {
    domain: 'localhost',
    apiUrl: 'https://deva.aedify.io',
    // apiUrl: 'https://platypus-dev.aedify.io'
    // apiUrl: 'http://localhost:8000'
  },
  {
    domain: 'deva.aedify.io',
    apiUrl: 'https://deva.aedify.io',
  },
  {
    domain: 'platypus-dev.aedify.io',
    apiUrl: 'https://platypus-dev.aedify.io',
  },
  {
    domain: 'devc.aedify.io',
    apiUrl: 'https://devc.aedify.io',
  },
  {
    domain: 'devj.aedify.io',
    apiUrl: 'https://devj.aedify.io',
  },
];

export const getServer = (currentDomain: string) => SERVER_CONFIGS.find(config =>
  currentDomain === config.domain || currentDomain.endsWith(`.${config.domain}`),
);
